import React from 'react';
import { useRouter } from 'next/navigation';
import { Logout } from '@mui/icons-material';
import { Drawer } from '@mui/material';
import { Container } from '@mui/material';
import { Typography } from '@mui/material';
import { IconButton } from '@mui/material';
import { ROUTES } from '@/constants/path.constants';
import { getUserInfo } from '@/utils/user.util';
import { FlexBox } from '@/views/appstore/reviews/components/post/meta/styles';
import { MOBILE_HEADER_HEIGHT } from '@/app/stylesguides';
import { useNavigationLogic } from '@/hooks/useNavigationLogic';
import RoundedButton from '../../atoms/RoundedButton';
import MobileNavigations from './MobileNavigations';

interface MobileSideBarProps {
  showSideBar: boolean;
  toggleDrawer: () => void;
  IsUserLoggedIn: boolean;
}

const MobileSideBar = ({ showSideBar, toggleDrawer, IsUserLoggedIn }: MobileSideBarProps) => {
  const router = useRouter();
  const { signOut } = useNavigationLogic();
  const appUserName = getUserInfo()?.appUserName ?? '';

  return (
    <Drawer
      open={showSideBar}
      onClose={toggleDrawer}
      hideBackdrop
      PaperProps={{
        sx: {
          padding: `${MOBILE_HEADER_HEIGHT + 16}px 0 16px`,
          width: '100%',
          overflowX: 'hidden',
          '&.MuiDrawer-paper': {
            transform: 'translateX(0) !important',
            transition: 'ease-in-out !important',
            opacity: showSideBar ? 1 : 0
          }
        }
      }}
    >
      <Container sx={{ padding: '0 22px', flexGrow: 1 }}>
        <MobileNavigations />
      </Container>
      <FlexBox style={{ width: '100%', gap: '6%' }}>
        {IsUserLoggedIn ? (
          <div className="w-full flex items-center justify-between px-5">
            <Typography variant="subtitle2">{appUserName}</Typography>
            <IconButton onClick={() => signOut()} sx={{ padding: 0, width: '24px' }} aria-label="로그아웃">
              <Logout />
            </IconButton>
          </div>
        ) : (
          <div className="pt-[10px] px-5 w-full flex flex-row gap-2 border-t-[1px] border-gray-100 pt-2">
            <RoundedButton
              className="flex-1 py-[7px] text-[#FFFFFF] text-sm font-semibold leading-[22px] bg-[#6B00D7] rounded-[8px]"
              label="회원가입"
              onClick={() => router.push(ROUTES.getSignUp())}
            />
            <RoundedButton
              className="flex-1 py-[7px] text-[#1F2937] text-sm font-semibold leading-[22px] bg-[#FFFFFF] border-[1px] border-[#E5E7EB] rounded-[8px]"
              label="로그인"
              onClick={() => router.push(ROUTES.getLogin())}
            />
          </div>
        )}
      </FlexBox>
    </Drawer>
  );
};

export default MobileSideBar;
